//@flow

import {connect} from 'react-redux';
import WellDone from './WellDone';
import {redirectAfterOrderingSIM} from '../../../modules/SignUp';
import {
  isLoadingSelector,
  errorSelector,
  hasLoginErrorSelector,
} from '../../../modules/LoadingStatus/reducer';
import {resetToDashboard} from '../../../modules/Navigation/actions';
import {eSimSelectedSelector, installESim} from '../../../modules/ESim';

const mapStateToProps = state => ({
  isLoading: isLoadingSelector(state, 'redirectAfterOrderingSIM'),
  error: errorSelector(state, 'redirectAfterOrderingSIM'),
  hasLoginError: hasLoginErrorSelector(state, 'redirectAfterOrderingSIM'),
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps = dispatch => ({
  redirectAfterOrderingSIM: () => dispatch(redirectAfterOrderingSIM()),
  goToDashboard: () => resetToDashboard(),
  installESim: () => installESim(),
});

export default connect(mapStateToProps, mapDispatchToProps)(WellDone);
